{
	"title": "Аудио-резюме",
	"list": {
		"title": "Все аудио",
		"subtitle": "Создай персонализированный подкаст, аудиокнигу и др",
		"empty": "Нет аудио-резюме",
		"create": "Создать аудио",
		"backToList": "К аудио-резюме",
		"errorTitle": "Не удалось загрузить аудио",
		"errorDescription": "Проверь соединение и попробуй ещё раз.",
		"retry": "Повторить",
		"emptyTitle": "Пока нет аудио-резюме",
		"emptyDescription": "AI создаст 4 формата озвучивания твоего материала: подкаст, лекция, аудиокнига или короткое резюме.",
		"emptyFilterTitle": "Нет аудио в этом формате",
		"emptyFilterDescription": "Создай аудио или выбери другой формат фильтра.",
		"filterAria": "Фильтр по формату",
		"filterAll": "Все",
		"searchPlaceholder": "Поиск по аудио…"
	},
	"card": {
		"listen": "Слушать",
		"resume": "Продолжить",
		"actions": "Действия",
		"open": "Открыть",
		"share": "Поделиться",
		"delete": "Удалить",
		"regenerate": "Перегенерировать"
	},
	"formats": {
		"podcast": "Подкаст",
		"podcastDescription": "Два голоса, диалог",
		"lecture": "Лекция",
		"lectureDescription": "Один голос, академический стиль",
		"audiobook": "Аудиокнига",
		"audiobookDescription": "Один голос, повествовательный стиль",
		"summary": "Краткое резюме",
		"summaryDescription": "Сжатое озвучивание"
	},
	"voices": {
		"single": "Один голос",
		"multi": "Несколько голосов",
		"selectVoice": "Выбрать голос",
		"descriptions": {
			"warm": "Тёплый, дружелюбный",
			"deep": "Глубокий, академический",
			"energetic": "Энергичный, подкаст",
			"calm": "Спокойный, аудиокнига",
			"young": "Молодёжный",
			"confident": "Уверенный, лектор"
		}
	},
	"generation": {
		"inProgress": "Генерация аудио…",
		"ready": "Аудио готово",
		"failed": "Не удалось создать аудио",
		"estimatedTime": "Примерно {minutes} мин"
	},
	"detail": {
		"downloadFailed": "Не удалось скачать аудио",
		"loadFailed": "Не удалось загрузить аудио",
		"retry": "Повторить",
		"generateFailedTitle": "Не удалось сгенерировать аудио",
		"generateFailedHint": "Перегенерируйте с теми же настройками или создайте новое.",
		"failReason": {
			"SOURCE_TOO_SHORT": {
				"title": "Материала слишком мало",
				"hint": "В источнике почти нет текста — из него не собрать пересказ. Добавьте материал побольше или выберите несколько."
			}
		},
		"createNew": "Создать новое",
		"downloadAria": "Скачать MP3",
		"shareAria": "Поделиться",
		"backMaterial": "Материал",
		"backSubsection": "К подсекции",
		"backAll": "Все аудио",
		"gen": {
			"autoRefresh": "Страница обновится автоматически — можно закрыть и вернуться позже.",
			"queued": {
				"title": "В очереди",
				"hint": "Скоро начнём — ждём свободного слота генерации."
			},
			"generating-script": {
				"title": "Готовим сценарий",
				"hint": "AI читает материал и пишет диалог. Обычно 20–60 секунд."
			},
			"generating-tts": {
				"title": "Синтезируем озвучку",
				"hint": "Озвучиваем реплики выбранными голосами. Чем длиннее аудио, тем дольше."
			}
		},
		"regenerate": "Перегенерировать",
		"durationShortfall": "Короче запрошенного",
		"durationShortfallHint": "Запрошено {target} мин., получилось {actual}. Исходный материал короче — добавь ещё материалов или выбери меньшую длительность."
	},
	"player": {
		"play": "Воспроизвести",
		"pause": "Пауза",
		"skipBack": "−15 секунд",
		"skipForward": "+15 секунд",
		"speed": "Скорость",
		"volume": "Громкость",
		"settings": "Настройки воспроизведения",
		"download": "Скачать MP3",
		"close": "Закрыть плеер"
	},
	"miniPlayer": {
		"defaultTitle": "Аудио-резюме",
		"position": "Позиция воспроизведения",
		"close": "Закрыть плеер",
		"speedAria": "Скорость воспроизведения {rate}",
		"languageNote": "Эта запись на языке {language}"
	},
	"generateDialog": {
		"title": "Сгенерировать аудио-резюме",
		"material": "Материал",
		"materialPlaceholder": "Выбрать материал…",
		"materialSearch": "Найти материал…",
		"format": "Формат",
		"voicesLabel": "Голоса",
		"language": "Язык",
		"languagePlaceholder": "Язык",
		"voice": "Голос",
		"voicePlaceholder": "Голос",
		"voiceSearch": "Найти голос…",
		"estTitle": "Оценка генерации",
		"estDetail": "~{words} слов · ~{minutes} мин",
		"quotaExhausted": "Квота на этот месяц исчерпана. Обнови тариф, чтобы продолжить.",
		"cancel": "Отмена",
		"submit": "Создать аудио",
		"format.podcast.label": "Подкаст",
		"format.podcast.description": "Живой диалог двух ведущих",
		"format.lecture.label": "Лекция",
		"format.lecture.description": "Один голос, академический стиль",
		"format.audiobook.label": "Аудиокнига",
		"format.audiobook.description": "Повествовательный стиль, размеренно",
		"format.summary.label": "Резюме",
		"format.summary.description": "Сжатый пересказ основных тезисов",
		"estMinutes": "~{minutes} мин",
		"defaultTitle": "Аудио-резюме",
		"toast": {
			"queued": "Аудио поставлено в очередь. Уведомим, когда будет готово.",
			"failed": "Не удалось запустить генерацию",
			"deleted": "Аудио-резюме удалено",
			"deleteFailed": "Не удалось удалить",
			"downloadFailed": "Не удалось скачать аудио"
		}
	},
	"wizard": {
		"title": "Новое аудио-резюме",
		"description": "Настрой материал, формат, голоса и длительность за 4 шага.",
		"step.source": "Источник",
		"step.format": "Формат",
		"step.voices": "Голоса",
		"step.length": "Длительность",
		"step1Hint": "Выбери материал или загрузи новый — на его основе AI напишет сценарий.",
		"step2Hint": "Формат задаёт подачу и число голосов. Стиль уточняется ниже.",
		"step3Hint": "Подбери голоса — их можно прослушать перед запуском.",
		"step4Hint": "Чем длиннее аудио, тем дольше генерация и больше расход квоты.",
		"back": "Назад",
		"cancel": "Отмена",
		"next": "Дальше",
		"generate": "Сгенерировать",
		"submitting": "Запускаем…",
		"queued": "Запрос принят. Генерация запущена.",
		"errorNoMaterial": "Выберите материал.",
		"errorGeneric": "Не удалось запустить генерацию. Попробуйте снова.",
		"defaultTitle": "Аудио-резюме",
		"titleLabel": "Название",
		"titlePlaceholder": "Например, «Подкаст по главе 3»",
		"titleHint": "Используется в плеере и поиске.",
		"voiceMode": "Режим голосов",
		"voicePrimary": "Голос",
		"voiceHostA": "Ведущий A",
		"voiceHostB": "Ведущий B",
		"personaPreset.label": "Стиль персоны",
		"personaPreset.placeholder": "Выберите стиль…",
		"personaPreset.hint": "Определяет манеру общения ИИ-ведущих в пересказе.",
		"toast": {
			"deleted": "Аудио-резюме удалено",
			"deleteFailed": "Не удалось удалить",
			"downloadFailed": "Не удалось скачать MP3",
			"regenerateStarted": "Перегенерация запущена",
			"regenerateFailed": "Не удалось запустить перегенерацию"
		}
	},
	"voicePicker": {
		"placeholder": "Голос",
		"search": "Найти голос…",
		"preview": "Прослушать",
		"female": "Женский",
		"male": "Мужской",
		"neutral": "Нейтральный",
		"mood.energetic": "Энергичный",
		"mood.calm": "Спокойный",
		"mood.warm": "Тёплый",
		"mood.authoritative": "Властный",
		"mood.friendly": "Дружелюбный",
		"mood.neutral": "Нейтральный"
	},
	"voiceGrid": {
		"filterAll": "Все",
		"filterFemale": "Женские",
		"filterMale": "Мужские",
		"play": "Слушать",
		"playing": "Играет…",
		"stop": "Стоп",
		"empty": "Нет голосов для выбранного фильтра"
	},
	"lengthSlider": {
		"label": "Целевая длительность",
		"minutes": "{minutes} мин",
		"minutesShort": "{minutes}м"
	},
	"costPreview": {
		"title": "Стоимость генерации",
		"estimatedWords": "Примерно слов",
		"estimatedCost": "Стоимость",
		"quotaMinutes": "Списание из квоты",
		"targetDuration": "Длительность",
		"minutes": "{minutes} мин",
		"failed": "Не удалось рассчитать стоимость.",
		"quotaExceeded": "Лимита не хватит — обнови тариф или сократи длительность."
	},
	"scriptPreview": {
		"title": "Предпросмотр сценария",
		"placeholder": "Полный сценарий будет доступен после первой генерации. Сейчас AI получит ваши настройки и материал."
	},
	"transcript": {
		"title": "Транскрипт",
		"lineCount": "{count, plural, one {# реплика} few {# реплики} other {# реплик}}",
		"empty": "Сценарий ещё генерируется.",
		"unavailable": "Сценарий недоступен для этого аудио.",
		"seekToSegment": "Перейти к {ts}",
		"askAboutSegment": "Спросить про этот отрывок",
		"scrollToActive": "К текущей реплике",
		"citationOpen": "Источник {n}",
		"citationLabel": "Источник {n}",
		"citationLoading": "Превью недоступно для фрагмента {id}",
		"citationOpenMaterial": "Открыть в материале",
		"citationMaterialFallback": "Материал",
		"citationChunkOrder": "Фрагмент {n}",
		"citationGroupAria": "{count, plural, one {# источник: {name}} few {# источника: {name}} many {# источников: {name}} other {# источника: {name}}}",
		"role": {
			"host": "Ведущий",
			"expert": "Эксперт",
			"student": "Студент",
			"narrator": "Рассказчик"
		},
		"askSegmentPrompt": "Поясни этот фрагмент аудио-резюме: «{text}»"
	},
	"tabs": {
		"transcript": "Транскрипт",
		"chat": "Чат"
	},
	"chat": {
		"title": "Чат по аудио-резюме",
		"ariaLabel": "Чат по аудио-резюме",
		"placeholder": "Спроси что-нибудь по аудио-резюме…",
		"send": "Отправить",
		"clear": "Очистить",
		"close": "Закрыть",
		"expand": "Чат",
		"collapse": "Скрыть чат",
		"thinking": "Думаю…",
		"answerFailed": "Не удалось получить ответ",
		"openInVoiceTutor": "Открыть голосового репетитора",
		"empty": {
			"title": "Спроси про аудио-резюме",
			"hint": "Любую реплику можно процитировать кнопкой справа в транскрипте."
		},
		"suggest": {
			"idea": "В чём главная идея?",
			"explainSimpler": "Объясни последний абзац проще",
			"whereToStart": "С чего начать читать материал?"
		},
		"quote": {
			"remove": "Убрать цитату"
		},
		"softCap": {
			"toast": "Похоже, тебе нужен полноценный репетитор",
			"hint": "С голосовым репетитором можно говорить вслух и пройти материал глубже."
		},
		"askTutor": "Спросить репетитора"
	},
	"share": {
		"title": "Публичная ссылка",
		"description": "Любой, у кого есть ссылка, сможет слушать запись без аккаунта.",
		"url": "Ссылка",
		"copy": "Копировать",
		"copyError": "Не удалось скопировать.",
		"create": "Создать ссылку",
		"revoke": "Отозвать",
		"revoked": "Доступ закрыт.",
		"error": "Не удалось обновить доступ.",
		"close": "Закрыть",
		"notShared": "Запись пока не опубликована.",
		"publicWarning": "Ссылка действует, пока ты её не отзовёшь.",
		"publicPage": {
			"createOwn": "Создать своё",
			"heading": "Аудио-резюме",
			"subheading": "Расшаренная запись",
			"error": "Запись недоступна или ссылка отозвана.",
			"footerHint": "Создано на StudyHub —",
			"footerCta": "попробуй бесплатно",
			"position": "Позиция воспроизведения",
			"play": "Воспроизвести",
			"pause": "Пауза",
			"loading": "Загружаем аудио…",
			"download": "Скачать аудио"
		}
	},
	"generating": {
		"phases": {
			"script": {
				"title": "Готовим сценарий",
				"description": "AI анализирует материал и пишет диалог"
			},
			"tts": {
				"title": "Синтезируем озвучку",
				"description": "Голоса оживают в одном TTS-вызове"
			},
			"finalize": {
				"title": "Финализируем",
				"description": "Сводим аудио и нормализуем громкость"
			}
		}
	},
	"citations": {
		"tooltip": {
			"openMaterial": "Открыть в материале",
			"chunkPreviewLabel": "Фрагмент материала"
		},
		"footnoteAriaLabel": "Источник {n}"
	},
	"step1": {
		"tabs": {
			"aria": "Источник",
			"existing": "Из материалов",
			"upload": "Загрузить",
			"link": "Ссылка",
			"text": "Текст"
		},
		"selectMaterials": "Выбрать материалы",
		"materialsSelected": "{count, plural, one {# материал выбран} few {# материала выбрано} many {# материалов выбрано} other {# материалов выбрано}}",
		"collectionSelected": "Папка: {name}",
		"changeSelection": "Изменить",
		"materialAdded": "Материал добавлен"
	},
	"audioRecap": {
		"presetPicker": {
			"label": "Стилевое направление",
			"hint": "Выберите подачу — она задаст тон и стиль аудио.",
			"exampleAria": "Пример для пресета {name}",
			"exampleClose": "Закрыть"
		},
		"presets": {
			"podcast-friend": {
				"label": "Объясни как другу",
				"description": "Ведущие говорят простым языком, используют бытовые аналогии и сразу объясняют термины через знакомые слова.",
				"example": "Привет! Сегодня разбираем тему…"
			},
			"podcast-deep": {
				"label": "Глубокое погружение",
				"description": "Ведущие разбирают нюансы, исключения и пограничные случаи, спорят между собой и часто ссылаются на источник.",
				"example": "Но есть важный нюанс…"
			},
			"podcast-debate": {
				"label": "Спор экспертов",
				"description": "Pro/contra-подача: один защищает позицию, другой оппонирует. Провокационные вопросы, разные точки зрения.",
				"example": "А я с этим категорически не согласен!"
			},
			"podcast-story": {
				"label": "Сторителлинг",
				"description": "Подача через историю или кейс. Эмоциональная вовлечённость, повествовательная арка.",
				"example": "Представь, что ты…"
			},
			"podcast-fast": {
				"label": "Быстрый разбор",
				"description": "Энергичный темп, факты-молнии, короткие реплики, без воды. Подходит для повторения.",
				"example": "Поехали! Главное — это…"
			},
			"lecture-basic": {
				"label": "Базовый курс",
				"description": "С нуля, термины раскрываются при первом появлении, ровный темп. Слушатель — новичок.",
				"example": "Начнём с самых основ…"
			},
			"lecture-exam": {
				"label": "Перед экзаменом",
				"description": "Фокус на определениях, формулах и типовых ошибках. Часто «запомни», «важно», «типичная ошибка».",
				"example": "Запомни это определение…"
			},
			"lecture-review": {
				"label": "Для повторения",
				"description": "Предполагает знание предмета. Акцент на связях между темами, бежит по верхам.",
				"example": "Освежим в памяти ключевые связи…"
			},
			"lecture-practice": {
				"label": "Связь с практикой",
				"description": "Каждый теоретический блок завершается реальным применением, задачей или кейсом.",
				"example": "А теперь применим это на практике…"
			},
			"lecture-source": {
				"label": "С опорой на источник",
				"description": "Частые отсылки «как сказано в материале», цитатность, минимум интерпретации.",
				"example": "Как сказано в материале…"
			},
			"audiobook-artistic": {
				"label": "Художественный пересказ",
				"description": "Атмосфера, образы, метафоры. Длинные предложения, выразительность.",
				"example": "Представьте полотно знаний…"
			},
			"audiobook-documentary": {
				"label": "Документальный",
				"description": "Нейтральный тон, факты, хронология. Без художественных украшений.",
				"example": "В 1687 году…"
			},
			"audiobook-bio": {
				"label": "Биографический",
				"description": "Через судьбу автора идеи. Акцент на «как пришёл к этому открытию».",
				"example": "История начинается с человека…"
			},
			"audiobook-context": {
				"label": "С отступлениями",
				"description": "Вставки культурного и исторического фона. «Чтобы понять X, надо вспомнить Y».",
				"example": "Чтобы понять это, вспомним эпоху…"
			},
			"summary-bullets": {
				"label": "Только тезисы",
				"description": "Bullet-style подача без воды. Каждый тезис — отдельная фраза.",
				"example": "Тезис первый…"
			},
			"summary-tldr": {
				"label": "TL;DR + цифры",
				"description": "Ключевые числа, даты, имена. Минимум контекста.",
				"example": "TL;DR: три цифры, две даты…"
			},
			"summary-weak-spots": {
				"label": "Что повторить",
				"description": "Фокус на сложных и слабых местах из материала.",
				"example": "Что чаще всего вызывает сложности…"
			},
			"summary-flashcards": {
				"label": "Карточки наоборот",
				"description": "Структура «вопрос → пауза → ответ» для аудио-повторения.",
				"example": "Вопрос. [пауза] Ответ."
			}
		},
		"customBrief": {
			"toggle": "Свои пожелания (необязательно)",
			"hint": "Эти пожелания будут учтены поверх выбранного стиля.",
			"counter": "{count} / {max}",
			"placeholders": {
				"0": "Например: «Сделай акцент на формулах»",
				"1": "Например: «Я готовлюсь к экзамену по физике»",
				"2": "Например: «Объясни так, чтобы понял пятилетний»",
				"3": "Например: «Подробнее про практическое применение»",
				"4": "Например: «Используй больше примеров из реальной жизни»"
			}
		}
	},
	"persona": {
		"wizard": {
			"label": "Стиль персоны",
			"description": "Выберите архетип ведущих для подкаста",
			"proOnly": "Доступно на тарифе Pro"
		},
		"presets": {
			"podcast": {
				"default": {
					"label": "Любопытный ведущий + наставник-эксперт",
					"description": "Классический формат: ведущий задаёт вопросы, эксперт объясняет"
				},
				"skeptical": {
					"label": "Скептик-интервьюер + терпеливый учитель",
					"description": "Ведущий въедливо задаёт каверзные вопросы, эксперт спокойно разбирает каждый"
				},
				"enthusiastic": {
					"label": "Восторженный новичок + мудрый ветеран",
					"description": "Свежий взгляд новичка против опыта мастера: «наивные» вопросы и истории из практики"
				}
			},
			"lecture": {
				"documentary": {
					"label": "Голос документалистики",
					"description": "Спокойный академический рассказчик в духе BBC"
				},
				"mentor": {
					"label": "Наставник",
					"description": "Тёплый, размеренный, словно объясняет любимому ученику"
				}
			},
			"audiobook": {
				"literary": {
					"label": "Литературный нарратор",
					"description": "Тёплый профессиональный голос аудиокниги"
				},
				"veteran": {
					"label": "Мудрый рассказчик",
					"description": "Возрастной, размеренный — рассказывает как старший наставник"
				}
			},
			"summary": {
				"briefing": {
					"label": "Брифер",
					"description": "Сжатый деловой инструктаж"
				},
				"curious": {
					"label": "Любопытный исследователь",
					"description": "Живая подача с интересом к материалу — не сухой отчёт"
				}
			}
		}
	},
	"intro": {
		"title": "Материал, который можно слушать",
		"body": "Из ваших источников пишется сценарий и озвучивается голосами. Это готовая запись, а не разговор: отвечать ей не нужно.",
		"bullets": [
			"Четыре формата: подкаст, лекция, аудиокнига, выжимка",
			"Один голос или диалог из нескольких",
			"Текст подсвечивается синхронно со звуком"
		]
	}
}
